import { render, staticRenderFns } from "./ActiveCompany.vue?vue&type=template&id=f2ce1558&"
import script from "./ActiveCompany.vue?vue&type=script&lang=js&"
export * from "./ActiveCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports